<template>
  <f7-toolbar bottom>
    <f7-row class="wd-100">
      <f7-col>
        <f7-link href="/" icon-md="material:home"></f7-link>
      </f7-col>
      <f7-col>
        <!-- <f7-link href="/" @click="$f7route.context = { seccion: 'whislist' }" class="heart" icon-md="material:favorite"></f7-link> -->
        <f7-link href="/" @click="$f7route.context = { seccion: 'whislist' }" class="heart custom-navbar no-ripple">
            <f7-icon class="heart" md="material:favorite" style="color: #a94442 !important;">
              <template v-if="$wishlist.total() > 0">
                <f7-badge class="fs-12 bold" color="red">{{ $wishlist.total() }}</f7-badge>
              </template>
            </f7-icon>
        </f7-link>
      </f7-col>
      <f7-col>
        <template v-if="pieza">
          <f7-link external target="_blank" :href="encodeURI(`https://wa.me/5218120140511?text=Me gustaría me dieran información del anillo ${pieza.name} (${pieza.cve})`)">
            <img src="assets/img/whatsapp.svg" alt="" width="24">
          </f7-link>
        </template>
        <template v-else>
          <f7-link external target="_blank" href="https://wa.me/5218120140511?text=Me gustaría recibir información">
            <img src="assets/img/whatsapp.svg" alt="" width="24">
          </f7-link>
        </template>
      </f7-col>
      <f7-col>
        <!-- <f7-link href="/" @click="$f7route.context = { seccion: 'carrito' }" class="gray" icon-md="material:shopping_basket"></f7-link> -->
        <f7-link href="/" @click="$f7route.context = { seccion: 'carrito' }" class="gray no-ripple">
            <f7-icon md="material:shopping_basket">
              <template v-if="storage.carrito.length > 0">
                <f7-badge class="fs-12 bold" color="red">{{ storage.carrito.length }}</f7-badge>
              </template>
            </f7-icon>
        </f7-link>
      </f7-col>
      <f7-col>
        <f7-link href="/" @click="$f7route.context = { seccion: 'cuenta' }" class="gray" icon-md="material:account_circle"></f7-link>
      </f7-col>
    </f7-row>
  </f7-toolbar>
</template>

<script>
export default {
  props: ['pieza']
}
</script>

<style>
.gray > .icon{
  color: #6c757d;
}
</style>
